import { Heading } from '@kpa/kul';
import React, { FC, ReactNode, useEffect, useState } from 'react';
import { NyhetsBlockResponse } from '../../types/blocks';
import { NyhetResponse, NyhetsarkivResponse } from '../../types/pages';
import Nyhet from './Nyhet';
import styles from './Nyhetslista.module.css';

export type Nyheter = NyhetsarkivResponse | NyhetsBlockResponse;

type NyhetslistaProps = {
  nyhetslista: Nyheter;
};

const Nyhetslista: FC<NyhetslistaProps> = ({ nyhetslista }): ReactNode => {
  const [nyhetsBlock, setNyhetsBlock] = useState<Map<number, NyhetResponse[]>>(new Map<number, NyhetResponse[]>());

  useEffect(() => {
    const block = new Map<number, NyhetResponse[]>();
    nyhetslista.nyheter.forEach((nyhet) => {
      const år = new Date(nyhet.publiceringsdatum).getFullYear();
      block.set(år, [...block.get(år) ?? [], nyhet]);
    });
    setNyhetsBlock(block);
  }, [nyhetslista]);

  return (
    <div className={styles.container}>
      {nyhetslista.rubrik && <Heading className={styles.header} headingLevel={1}>{nyhetslista.rubrik}</Heading>}
      {
        [...nyhetsBlock.entries()].map(([år, nyheter]) => (
          <React.Fragment key={år}>
            <Heading className={styles.headerÅr} headingLevel={2}>{år}</Heading>
            <ul className={styles.ul}>
              {nyheter.length > 0 && nyheter.map(nyhet => (
                <li className={styles.li} key={nyhet.id}>
                  <Nyhet nyhet={nyhet}></Nyhet>
                </li>
              ))}
            </ul>
          </React.Fragment>
        ))
      }
    </div>
  );
};

export default Nyhetslista;
